import VueCompositionAPI from "@vue/composition-api"
import { ModalPlugin, ToastPlugin } from "bootstrap-vue"
import Vue from "vue"
import VueGeolocation from "vue-browser-geolocation"
import VueHtmlToPaper from "vue-html-to-paper"
import * as VueGoogleMaps from "vue2-google-maps"

import i18n from "@/libs/i18n"
import App from "./App.vue"
import router from "./router"
import store from "./store"

// Global Components
import "./global-components"

// 3rd party plugins
import "@/libs/acl"
import "@/libs/clipboard"
import "@/libs/portal-vue"
import "@/libs/sweet-alerts"
import "@/libs/toastification"
import "@/libs/tour"
import "@/libs/vue-select"
import "@axios"

// Axios Mock Adapter
import "@/@fake-db/db"
import { fetchValidateToken } from "./auth/EnsureTokenIsValid"

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueGeolocation)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
// require("@core/assets/fonts/feather/iconfont.css") // For form-wizard

// import core styles
require("@core/scss/core.scss")

// import assets styles
require("@/assets/scss/style.scss")

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCy0g61k3g2CkH3BIDLi6Fsi0SfAzHz5VE",
    libraries: "places",
  },
})

Vue.use(VueHtmlToPaper)

fetchValidateToken()

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
